import * as React from 'react';

import { onInsideClick } from './helpers';
import { OptionalDropdown } from './optional_dropdown';
import { filterChange, filterClick } from './tracking';

const s = require('../search_filters.css');

interface IProps {
  value?: string;
  onChange(value: string): void;
}

export const BedroomFilter = (props: IProps) =>
  <div
    className={s['c-filters-field']}
    onClick={onInsideClick(() => filterClick('BedroomsCount'))}
  >
  <OptionalDropdown
    value={ props.value || 0 }
    label={ props.value ? '' : 'Спален' }
    onChange={(value: string) => { filterChange('BedroomsCount', value); props.onChange(value); }}
    values={[
      { value: 'no_matter', label: 'Не важно' },
      { value: '1', label: 'от 1' },
      { value: '2', label: 'от 2' },
      { value: '3', label: 'от 3' },
      { value: '4', label: 'от 4' },
      { value: '5', label: 'от 5' },
      { value: '6', label: 'от 6' },
    ]}/>
  </div>;
